export const BASE_URL = "https://medsov.com";
export const HF_TOKEN = process.env.HF_TOKEN || "";
